// extracted by mini-css-extract-plugin
module.exports = {"wrapperInner":"Integrations-module--wrapperInner--bM3gt","integrationsImg":"Integrations-module--integrationsImg--35juu","content":"Integrations-module--content--sZsSM"};